import Moment from 'moment'

Moment.locale('en')

export function toDate(date, format = 'MMM Do') {
  if (date && typeof date.toDate === 'function') {
    date = date.toDate()
  }
  return Moment(date).format(format)
}